import moment from "moment";

export function convertLocalToUtc(date) {
    // This does not work if the date is a string
    // var dateUtc2 = moment.utc(this.note.date).format('YYYY-MM-DD HH:mm:ss');
    // This works whether date is a string or Date object.
    let utcDate = moment(date)
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");
    return utcDate;
}

export function createDefaultTitle(bookTitle) {
    return bookTitle +
        " " +
        moment()
            .local()
            .format("YYYY-MM-DD HH:mm:ss");
}

export function convertUtcToLocal(date) {
    if (date === null) {
        date = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    let dateUtc = moment.utc(date);
    // let localDate = moment(dateUtc).local().format('YYYY-MM-DD HH:mm:ss');
    let localDate = moment(dateUtc)
        .local()
        .toDate();
    return localDate;
}